import { render, staticRenderFns } from "./TheLayoutFooter.vue?vue&type=template&id=42913797"
import script from "./TheLayoutFooter.vue?vue&type=script&lang=js"
export * from "./TheLayoutFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports